import { render, staticRenderFns } from "./FormPageItem.vue?vue&type=template&id=18a48cda"
import script from "./FormPageItem.vue?vue&type=script&lang=js"
export * from "./FormPageItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports